import React from "react";

const RecipientNameComponent = ({ currentRecord }) => {
  return (
    <div className="p-6 mb-8 shadow-xl bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl">
      <h2 className="mb-4 text-2xl font-bold text-indigo-700">
        Recipient Information
      </h2>
      <div className="flex flex-col items-start justify-between space-y-4 md:flex-row md:items-center md:space-y-0">
        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">Name</span>
          <span className="text-xl font-semibold text-gray-800">
            {currentRecord?.name}
          </span>
        </div>
        <div className="flex flex-col items-start md:items-end">
          <span className="text-sm font-medium text-gray-500">
            Recipient Code
          </span>
          <span className="px-4 py-2 font-mono text-sm font-bold text-indigo-800 bg-indigo-100 rounded-full shadow-inner">
            {currentRecord?.recipient_code}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RecipientNameComponent;
